import { VedaWrapper } from "./VedaWrapper";
import Editor from "./Editor";
import useShaderManager from "./useShaderManager";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import DrawingCanvas from "./DrawingCanvas";
import checkpoint0File from "./shaders/checkpoint0.txt";
import checkpoint1File from "./shaders/checkpoint1.txt";
import checkpoint2File from "./shaders/checkpoint2.txt";
import checkpoint3File from "./shaders/checkpoint3.txt";
import checkpoint4File from "./shaders/bonus.txt";
import checkpoint5File from "./shaders/bonus2.txt";
import checkpoint6File from "./shaders/shjam.txt";

import useIsMobile from "./useIsMobile";
import { useState, useEffect, useRef } from "react";
import useTouchEvents from "./useTouchEvents";
import useCanvasManager from "./useCanvasManager";

export function GLSLEditor() {
  let { id } = useParams();

  const { editorRef, yState, update } = useShaderManager((state) => state);
  const showEditor = useShaderManager((state) => state.showEditor);

  const [checkpoint0, loadCheckpoint0] = useState("");
  const [checkpoint1, loadCheckpoint1] = useState("");
  const [checkpoint2, loadCheckpoint2] = useState("");
  const [checkpoint3, loadCheckpoint3] = useState("");
  const [checkpoint4, loadCheckpoint4] = useState("");
  const [checkpoint5, loadCheckpoint5] = useState("");
  const [checkpoint6, loadCheckpoint6] = useState("");

  const hideCanvas = useCanvasManager((state) => state.hide);
  const updateCanvas = useCanvasManager((state) => state.update);
  const toggleCanvas = useCanvasManager((state) => state.toggleCanvas);

  const history = useHistory();
  const showEditorRef = useRef(true);
  const checkpoint = (value) => {
    if (!editorRef) return;
    editorRef.setValue("");
    editorRef.setValue(value);
    yState.set("frag", true);
  };
  const loadFile = (textFile, callback) => {
    fetch(textFile)
      .then((response) => response.text())
      .then((data) => {
        callback(data);
      });
  };
  useEffect(() => {
    loadFile(checkpoint0File, loadCheckpoint0);
    loadFile(checkpoint1File, loadCheckpoint1);
    loadFile(checkpoint2File, loadCheckpoint2);
    loadFile(checkpoint3File, loadCheckpoint3);
    loadFile(checkpoint4File, loadCheckpoint4);
    loadFile(checkpoint5File, loadCheckpoint5);
    loadFile(checkpoint6File, loadCheckpoint6);
  }, []);

  useEffect(() => {
    if (id === "workshop") {
      checkpoint(checkpoint0);
    } else {
      checkpoint(checkpoint4);
    }
  }, [id]);

  const hideEditor = () => {
    const currentValue = showEditorRef.current;
    showEditorRef.current = !currentValue;
    update("showEditor", !currentValue);
  };

  useEffect(() => {
    const keyHandler = (event) => {
      var name = event.key;
      var code = event.code;
      if (name === "Control") {
        // Do nothing.
        return;
      }
      if (event.ctrlKey) {
        if (name == "0") {
          hideEditor();
        }

        if (name == "9") {
          toggleCanvas();
        }
      }
    };

    document.addEventListener("keydown", keyHandler, false);

    return () => window.removeEventListener("resize", keyHandler);
  }, []);

  const compileCode = () => {
    yState.set("frag", true);
  };

  useTouchEvents({
    onDoubleTap: compileCode,
    onLongTap: hideEditor,
    onTap: () => null,
  });
  const isMobile = useIsMobile();
  return (
    <>
      {" "}
      {id.includes("workshop") ? (
        <div
          className="horizontal-bar"
          style={showEditor ? { display: "block" } : { display: "none" }}
        >
          <button className="bar-button" onClick={() => history.goBack()}>
            🏠
          </button>
          <button
            className="bar-button"
            onClick={() => checkpoint(checkpoint0)}
          >
            {isMobile ? "STX" : "SINTAXIS"}
          </button>
          <button
            className="bar-button"
            onClick={() => checkpoint(checkpoint1)}
          >
            {isMobile ? "CHK 1" : "CHECKPOINT 1"}
          </button>
          <button
            className="bar-button"
            onClick={() => checkpoint(checkpoint2)}
          >
            {isMobile ? "CHK 2" : "CHECKPOINT 2"}
          </button>
          <button
            className="bar-button"
            onClick={() => checkpoint(checkpoint3)}
          >
            {isMobile ? "CHK 3" : "CHECKPOINT 3"}
          </button>
          <button
            className="bar-button"
            onClick={() => checkpoint(checkpoint4)}
          >
            {isMobile ? "BI" : "BONUS I"}
          </button>
          <button
            className="bar-button"
            onClick={() => checkpoint(checkpoint5)}
          >
            {isMobile ? "BII" : "BONUS II"}
          </button>
          <button
            className="bar-button"
            style={{ zIndex: 45 }}
            onClick={() => updateCanvas("hide", !hideCanvas)}
          >
            🖍️
          </button>
        </div>
      ) : (
        <div className="horizontal-bar">
          <div className="bar-text">Estamos en {id}</div>
          <button
            className="bar-button"
            onClick={() => checkpoint(checkpoint6)}
          >
            ver ejemplo
          </button>
        </div>
      )}
      <Editor show={showEditor} />
      <VedaWrapper />
      <DrawingCanvas show={hideCanvas} />
    </>
  );
}
